import client from '../client'

export const getAvailableGroupsKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Members/GetAvailableGroups?BenefitsProgramId=`

export async function getAvailableGroups(BenefitsProgramId) {
  return client(getAvailableGroupsKey + BenefitsProgramId)
}
